import styles from "./ForbiddenPage.module.sass";

import Footer from "../Login/Footer";
import Icon from "colbi_web_ui/lib/components/Icon/Icon";

import SovosButton from "mosaic-react/sovos-button";
import { useAuth } from "react-oidc-context";
import { logout } from "../../store/actions";
import { connect } from "react-redux";
import { SovosIcon } from "mosaic-react";
import { ArrowOutward, Logout } from "mosaic-react-icons";

const ForbiddenAccessPage = (props) => {
    const auth = useAuth();

    return (
        <div className={styles["root"]}>
            <div className={styles["full-container"]}>
                <Icon name="no-access" style={{ width: 130, height: 130 }} />
                <h2>SAF-T</h2>
                <div className={styles["text-center"]}>
                    <p>You don’t have access to this application.</p>
                    <p>Please contact your administrator for access.</p>
                </div>

                <div className={styles["help-container"]}>
                    <div className={styles["contact-support"]}>
                        <SovosButton
                            onClick={() =>
                                (window.location.href = "https://sovos.com/vat/products/saf-t/")
                            }
                            size={"medium"}
                            startIcon={
                                <SovosIcon>
                                    <ArrowOutward />
                                </SovosIcon>
                            }
                        >
                            Learn More
                        </SovosButton>
                        <SovosButton
                            size={"medium"}
                            variant={"text"}
                            onClick={() => {
                                props.logout(auth);
                            }}
                            startIcon={
                                <SovosIcon>
                                    <Logout />
                                </SovosIcon>
                            }
                        >
                            Logout
                        </SovosButton>
                    </div>
                    <SovosButton
                        size={"medium"}
                        variant={"text"}
                        color={"#000000"}
                        onClick={() => (window.location.href = "https://sovos.com/support/")}
                    >
                        Need Help?&nbsp;
                        <span>Contact Support</span>
                    </SovosButton>
                </div>
            </div>
            <Footer className={styles["footer"]} />
        </div>
    );
};

export default connect(() => ({}), { logout })(ForbiddenAccessPage);
